export default [
  {
    path: "/releaseReq", // 发布需求
    name: "releaseReq",
    component: () =>
      import(
        /* webpackChunkName: "hall" */ "../views/ReleaseRequirements/index.vue"
      ),
    meta: {
      eventId: "W-DM-27-V1",
      eventName: "需求发布曝光",
      module: "需求大厅",
    },
  },
  {
    path: "/demandHall", // 需求大厅
    name: "demandHall",
    component: () =>
      import(/* webpackChunkName: "hall" */ "../views/DemandHall/index.vue"),
    meta: {
      eventId: "W-DM-25-V1",
      eventName: "需求列表曝光",
      module: "需求大厅",
    },
  },
  {
    path: "/demandDetail", // 需求详细
    name: "demandDetail",
    component: () =>
      import(/* webpackChunkName: "hall" */ "../views/DemandDetail/index.vue"),
    meta: {
      eventId: "W-DM-26-V1",
      eventName: "需求详情曝光",
      module: "需求大厅",
    },
  },
  {
    path: "/capabilityHall", // 能力大厅
    name: "capabilityHall",
    component: () =>
      import(
        /* webpackChunkName: "hall" */ "../views/CapabilityHall/index.vue"
      ),
    meta: {
      eventId: "W-CH-28-V1",
      eventName: "能力列表曝光",
      module: "能力大厅",
    },
  },
  {
    path: "/checkProjectDetail", // 检测项目详情
    name: "checkProjectDetail",
    component: () =>
      import(
        /* webpackChunkName: "hall" */ "../views/CheckProjectDetail/index.vue"
      ),
    meta: {
      eventId: "W-CH-29-V1",
      eventName: "能力详情曝光",
      module: "能力大厅",
    },
  },
];
